const isRunningOnClient = () => typeof window !== "undefined";

export default isRunningOnClient;
